import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllServiceLines() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllServiceLineByReportingUser`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCasebuReportingUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllCasebuReportingUser(page, limit,search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine${page ? `?page=${page}&limit=${limit}&search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCasebuReportingUserSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine${search ? `?search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getFollowingCasebyUser(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedServiceLine${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllFollowingCasebyUser(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedServiceLine${page ? `?page=${page}&limit=${limit}&search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getFollowingCasebyUserSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedServiceLine${search ? `?search=${search}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getMyServiceLine(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllMyServiceLine${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getSharedServiceLine() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedServiceLine`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllServiceLineByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllServiceLineByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getServiceLineDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByServiceLineId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createServiceLine(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createServiceLine`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateServiceLine(id, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateServiceLine/${id}`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteServiceLine(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteServiceLine/${id}`, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
       getCasebuReportingUser,
    getAllCasebuReportingUser,
    getCasebuReportingUserSearch,
    getFollowingCasebyUser,
    getAllFollowingCasebyUser,
    getFollowingCasebyUserSearch,
    FetchAllServiceLines,
    getMyServiceLine,
    getSharedServiceLine,
    getAllServiceLineByCompany,
    getServiceLineDetails,
    createServiceLine,
    updateServiceLine,
    deleteServiceLine
}